/**
 * HTML 입력칸은 창을 연 키가 글자로 들어가지 않게, 그 키를 뗀 뒤에 포커스한다.
 */
export function focusAfterKey(el: HTMLElement | null): void {
  if (!el) return;
  let done = false;
  const go = (): void => {
    if (done) return;
    done = true;
    window.removeEventListener('keyup', go, true);
    el.focus();
  };
  window.addEventListener('keyup', go, true);
  window.setTimeout(go, 80);
}
